import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import React, { useContext } from 'react';
import { EditableInfoContainer } from '@dealstack/frontend/shared/components/EditableInfoContainer/EditableInfoContainer.tsx';
import { PersonDataContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/usePersonData.ts';
import { MipTile } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/InvestmentProgrammeSection/components/MipTile.tsx';
import { PersonType } from '@dealstack/shared/lib/generated';
import { LinkInvestmentProgrammeDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/InvestmentProgrammeDrawer/LinkInvestmentProgrammeDrawer.tsx';
import { useParams } from 'react-router-dom';
import { UnlinkPersonInvestmentProgrammeDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/InvestmentProgrammeDrawer/UnlinkPersonInvestmentProgrammeDrawer.tsx';

export const InvestmentProgrammeSection = ({
	hasEditorPermission,
}: {
	hasEditorPermission: boolean;
}) => {
	const tCapManage = useTranslationCapManage();
	const { dealId } = useParams();
	const {
		investmentProgrammes,
		linkInvestmentProgrammeToPerson,
		setLinkInvestmentProgrammeToPerson,
		unlinkInvestmentProgramme,
		setUnlinkInvestmentProgramme,
		selectedEntityType,
	} = useContext(PersonDataContext);
	const isPersonLegal = selectedEntityType === PersonType.LEGAL;

	return (
		<>
			{investmentProgrammes.length ? (
				<EditableInfoContainer
					title={tCapManage('basic_details.investment_programme.title')}
					isEdit={false}
					hasEditorPermission={hasEditorPermission}
					gridColumns={2}
					useGrid={true}
					childrenPadding="0.5rem"
					onAdd={
						isPersonLegal ? undefined : () => setLinkInvestmentProgrammeToPerson(true)
					}
				>
					{investmentProgrammes.map((mip) => (
						<MipTile
							key={mip.id}
							mip={mip}
							dealId={dealId ?? ''}
							isLegal={isPersonLegal}
							onRemove={setUnlinkInvestmentProgramme}
							hasEditPermission={hasEditorPermission}
						/>
					))}
				</EditableInfoContainer>
			) : null}

			{hasEditorPermission && (
				<>
					<LinkInvestmentProgrammeDrawer
						opened={linkInvestmentProgrammeToPerson}
						onClose={() => setLinkInvestmentProgrammeToPerson(false)}
						hasPermission={hasEditorPermission}
					/>

					<UnlinkPersonInvestmentProgrammeDrawer
						opened={!!unlinkInvestmentProgramme}
						onClose={() => setUnlinkInvestmentProgramme(null)}
						linkedMip={unlinkInvestmentProgramme}
					/>
				</>
			)}
		</>
	);
};
